const CartPage = () => {
    return (
        <div>
            Orders Page
        </div>
    )
}

export default CartPage;